export const FB_SCOPE_LOGIN = {
  scope: 'ads_management',
};

export const FB_RETURN_SCOPES = {
  return_scopes: true,
};
